<p>
  discount-proposal works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/customer/discount-proposal/discount-proposal.component.html